module.exports = __webpack_public_path__ + "images/contact.a0eb30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/home/contact.png
// module id = smDG
// module chunks = 19